import { render } from "./private-training.vue?vue&type=template&id=19137d1a&scoped=true"
import script from "./private-training.vue?vue&type=script&lang=js"
export * from "./private-training.vue?vue&type=script&lang=js"

import "./private-training.vue?vue&type=style&index=0&id=19137d1a&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19137d1a"]])

export default __exports__